export enum StoreKeys {
	app = 'app',
	componentForm = 'componentForm',
}
